import { DialogComponent } from '@theme/dialog';

/**
 * Custom element managing the booking navigation drawer.
 * Extends DialogComponent for show/close/toggle dialog behavior with animations.
 *
 * @extends {DialogComponent}
 */
class BookingDrawerComponent extends DialogComponent {
  requiredRefs = ['dialog'];
}

if (!customElements.get('booking-drawer-component')) {
  customElements.define('booking-drawer-component', BookingDrawerComponent);
}
